import React, {useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import AppProvider from './contexts/AppProvider';
import DataLoader from './components/DataLoader/DataLoader';
import View from './containers/View/View';
import Scanner from './containers/Scanner/Scanner';
import Product from './containers/Product/Product';
import Cart from './containers/Cart/Cart';
import Identification from './containers/Identification/Identification';
import AddressCopy from './containers/AddressCopy/AddressCopy';
import NotFound from './components/NotFound/NotFound';
import Viewport from './helpers/Viewport';
import Storage from './helpers/Storage';
import Debug from './helpers/Debug';
import {fingerprinter} from './helpers/Fingerprinter';
import './App.css';

function App() {
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        Debug.printToLog('info', `[Viewport] Width: ${Viewport.dimensions.width} | Height: ${Viewport.dimensions.height}`);
        generateFingerprint();
    }, []);

    const generateFingerprint = () => {
        const currentFingerprint = Storage.getFingerprint();
        if (currentFingerprint) Debug.printToLog('info', `[Fingerprint]: ${currentFingerprint}`);
        fingerprinter.generate(true)
            .then((data) => {
                const newFingerprint = data.hash;
                if (!currentFingerprint && newFingerprint) {
                    Debug.printToLog('info', `[Fingerprint] ${newFingerprint}`);
                    Storage.setFingerprint(newFingerprint);
                }
                Storage.setSession(newFingerprint);
                Debug.printToLog('info', `[Session] ${newFingerprint}`);
            })
            .catch((error) => {
                Debug.printToLog('error', `Unable to generate fingerprint: ${error}`);
                Storage.removeFingerprint();
            })
            .then(() => {
                setIsLoading(false);
            });
    };

    const renderLoader = () => {
        return (
            <div className='app_loader'>
                <DataLoader message='Iniciando...' loaderSize={80}/>
            </div>
        );
    };

    const renderRouter = () => {
        return (
            <React.Fragment>
                <Router>
                    <Routes>
                        <Route path='/' element={renderScanner()}/>
                        <Route path='/product/:productId' element={renderProduct()}/>
                        <Route path='/cart' element={renderCart()}/>
                        <Route path='/identification' element={renderIdentification()}/>
                        <Route path='/address-copy/:clientType' element={renderAddresCopy()}/>
                        <Route path='*' element={renderNotFound()}/>
                    </Routes>
                </Router>
            </React.Fragment>
        );
    };

    const renderScanner = () => {
        const section = 'scanner-view';
        return (
            <View key={section} section={section} showNavbar={false} showCartLink={false}>
                <Scanner section={section}/>
            </View>
        );
    };

    const renderProduct = () => {
        const section = 'product-view';
        return (
            <View key={section} section={section} showNavbar={true} showCartLink={true}>
                <Product section={section}/>
            </View>
        );
    };

    const renderCart = () => {
        const section = 'cart-view';
        return (
            <View key={section} section={section} showNavbar={true} showCartLink={false}>
                <Cart section={section}/>
            </View>
        );
    };

    const renderIdentification = () => {
        const section = 'identification-view';
        return (
            <View key={section} section={section} showNavbar={true} showCartLink={true}>
                <Identification section={section}/>
            </View>
        );
    };

    const renderAddresCopy = () => {
        const section = 'address-copy-view';
        return (
            <View key={section} section={section} showNavbar={true} showCartLink={true}>
                <AddressCopy section={section}/>
            </View>
        );
    };

    const renderNotFound = () => {
        const section = 'not-found-view';
        return (
            <View key={section} section={section} showNavbar={true} showCartLink={true}>
                <NotFound section={section}/>
            </View>
        );
    };

    return (
        <div className='app'>
            <AppProvider>
                {isLoading && renderLoader()}
                {!isLoading && renderRouter()}
            </AppProvider>
        </div>
    );
}

export default App;